import { render, staticRenderFns } from "./ContabilitaDocumentoRigheEditComponent.vue?vue&type=template&id=58d7e745&scoped=true"
import script from "./ContabilitaDocumentoRigheEditComponent.vue?vue&type=script&lang=js"
export * from "./ContabilitaDocumentoRigheEditComponent.vue?vue&type=script&lang=js"
import style0 from "./ContabilitaDocumentoRigheEditComponent.vue?vue&type=style&index=0&id=58d7e745&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d7e745",
  null
  
)

export default component.exports